import React, { FormEvent } from 'react';
import { useForm } from 'react-hook-form';
import SignupForm from './Signupform';
import { FormValues, Signupprops } from './Signup.types';
import Form from '../../../components/Form/Form';
import { signupService } from '../../../services/Auth/Auth';

const Signup = ({ showModalSuccess, showModalError, returnUrl }: Signupprops) => {
  const { register, handleSubmit, formState } = useForm<FormValues>();

  const signupRequest = React.useCallback(
    async (formValues: FormValues) => {
      try {
        await signupService(formValues);
        showModalSuccess();
      } catch (error) {
        showModalError(error.message);
      }
    },
    [showModalSuccess, showModalError]
  );

  const onSubmit = React.useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      handleSubmit(signupRequest)();
    },
    [signupRequest, handleSubmit]
  );

  return (
    <Form form={{ title: 'Registrarse', onSubmit, backHref: returnUrl }}>
      <SignupForm register={register} formState={formState} />
    </Form>
  );
};

export default Signup;
